import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './UI';

export default function Nav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;
  const tabStyle = (path) => ({
    padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer',
    fontFamily: 'var(--sans)', fontSize: 13, fontWeight: 500, textDecoration: 'none',
    background: isActive(path) ? 'var(--accent-dim)' : 'transparent',
    color: isActive(path) ? 'var(--accent)' : 'var(--text3)',
    transition: 'all 0.2s',
  });

  return (
    <nav style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 32px',
      borderBottom: '1px solid var(--border)', background: 'var(--bg)', position: 'sticky', top: 0, zIndex: 100,
      backdropFilter: 'blur(12px)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <div style={{
            width: 34, height: 34, borderRadius: 8, background: 'var(--accent)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 800,
            fontFamily: 'var(--mono)', color: '#000',
          }}>R2</div>
          <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)', fontFamily: 'var(--sans)', letterSpacing: '-0.02em' }}>Markets</span>
        </Link>

        <div style={{ display: 'flex', gap: 4 }}>
          <Link to="/" style={tabStyle('/')}>Marketplace</Link>
          <Link to="/about" style={tabStyle('/about')}>About</Link>
          {user?.role === 'buyer' && <Link to="/my-offers" style={tabStyle('/my-offers')}>My Offers</Link>}
          {user?.role === 'seller' && <Link to="/my-listings" style={tabStyle('/my-listings')}>My Listings</Link>}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {user ? (
          <>
            <div style={{ fontSize: 13, color: 'var(--text2)', fontFamily: 'var(--mono)' }}>
              {user.companyName}
              <span style={{
                marginLeft: 8, padding: '2px 8px', borderRadius: 4,
                background: user.role === 'seller' ? 'var(--blue-dim)' : 'var(--accent-dim)',
                color: user.role === 'seller' ? 'var(--blue)' : 'var(--accent)',
                fontSize: 11, fontWeight: 600, textTransform: 'uppercase',
              }}>{user.role}</span>
            </div>
            {user.role === 'seller' && (
              <Button small onClick={() => navigate('/create-listing')}>+ New Listing</Button>
            )}
            <Button small variant="ghost" onClick={() => { logout(); navigate('/'); }}>Logout</Button>
          </>
        ) : (
          <>
            <Button small variant="secondary" onClick={() => navigate('/login')}>Login</Button>
            <Button small onClick={() => navigate('/register')}>Register</Button>
          </>
        )}
      </div>
    </nav>
  );
}
